export const CURRENT_CONFIG = {

  // license
  appId: '168102', // You need to go to the development website to apply.
  appKey: '45a3c04f2ebf1860e5ff7a250237608', // You need to go to the development website to apply.
  appLicense: 'jfS0gKK/YlSxKK9tiHWD5Yrh1bEsRAZnXeLhZYB63iTQgMZESkR9bcL/7qxICJQhh+J/MjRCkH1Okat3sJdHmUrCKwH/o+GD0xtYQCbiZ4Opfgy49pmvPl4u3VGoxZnh39TpLkTZHKFS2T2j4+KAYwGrRZwLvXV0acRp1tZ3z6Q=', // You need to go to the development website to apply.

  baseURL: 'https://dev-dji-api.dronos.ai',
  websocketURL: 'wss://dev-dji-api.dronos.ai/manage/api/v1/ws',
  dronosBaseURL: 'https://development-api.dronos.ai',

  mqttHost: 'tcp://emqx-development-api.dronos.ai:1883',
  mqttUsername: 'pilot',
  mqttPassword: 'pilot123',
  mqttAccessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ3b3Jrc3BhY2VfaWQiOiJlM2RlYTBmNS0zN2YyLTRkNzktYWU1OC00OTBhZjMyMjgwNjkiLCJzdWIiOiJDbG91ZEFwaVNhbXBsZSIsInVzZXJfdHlwZSI6IjIiLCJuYmYiOjE3NTk3MjM3MDYsImxvZyI6IkxvZ2dlcltjb20uZGppLnNhbXBsZS5jb21tb24ubW9kZWwuQ3VzdG9tQ2xhaW1dIiwiaXNzIjoiREpJIiwiaWQiOiJiZTdjNmMzZC1hZmU5LTRiZTQtYjllYi1jNTUwNjZjMDkxNGUiLCJleHAiOjE3NTk4MTAxMDYsImlhdCI6MTc1OTcyMzcwNiwidXNlcm5hbWUiOiJwaWxvdCJ9.1BNm9YbZguraxM1PzFZax0YSW1gieBP1jp7Fm7gvOBI',

  missionObjectiveIds: ['690caeb2f00fc07f507471a2'],

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://18.139.88.246:1935/out/3104', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: '4321fd5bbd6c20b5784b377897f67ee8',

}
